export class AccentHour {
    private _totalSecond = 0;

    constructor(
        public id: number,
        public name: string,
        public color: string,
        public seconds: number,
    ){
    }

    set totalSecond(total: number) {
        this._totalSecond = total;
    }

    get totalSecond(): number {
        return this._totalSecond;
    }
}
